export default {
  data: () => ({
    $cuid: ""
  }),
  beforeCreate() {
    this.$cuid = this.$uuid();
  }
};
